import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TwtOrderContext } from '~/tenants/twt/model/TwtOrder';
import { PersonaType } from '~/tenants/common/TenantPersona';
import FormGroup from '~/components/form/FormGroup';
import TwtDetached from '~/tenants/twt/forms/TwtDetached';
import Message from '~/components/Message';
import React from 'react';

export function TwtMatterportFormInputs({ persona, create }: { persona: PersonaType; create: boolean }) {
  return (
    <FormGroup>
      <FormHorizontal label="Floors">
        <ZodFieldInput type="number" name="floors" />
      </FormHorizontal>
      <TwtDetached />
    </FormGroup>
  );
}

export default function TwtMatterportForm({ create, persona }: TenantPerformableFormProps<TwtOrderContext>) {
  return (
    <div className="space-y-4">
      {persona === PersonaType.CUSTOMER && create && (
        <>
          <Message type="warning">
            Matterport links are not currently allowed on Zillow.  If you would like your 3D scan to appear on Zillow, we strongly recommend selecting our Nucleus scans
          </Message>
          <iframe
            src="https://my.matterport.com/show/?m=4vJWqFBTcwy"
            className="w-full h-[400px] rounded-theme overflow-hidden"
          />
        </>
      )}
      <TwtMatterportFormInputs persona={persona} create={create} />
    </div>
  );
}
